/**
 * 🌲 PRESENTATION EXTRACTOR (Relational Sync)
 * Location: src/registered/site-admin/components/Workflow-esg/services/presentationExtractor.js
 */
export default function extractPresentation(rows, indexMap) {
  const concepts = {};
  const roots = [];

  const getIdx = (target) => {
    const key = Object.keys(indexMap).find(k => 
      k.toLowerCase().trim() === target.toLowerCase().trim()
    );
    return indexMap[key];
  };

  const L_IDX = getIdx("Level");
  const T_IDX = getIdx("Technical Name");
  const E_IDX = getIdx("Label en");
  const R_IDX = getIdx("Role"); // 👈 CRITICAL: This is the Master Chapter ID
  const A_IDX = getIdx("Abstract");

  for (let i = 1; i < rows.length; i++) {
    const r = rows[i];
    const id = r[T_IDX];
    const level = parseInt(r[L_IDX]);

    if (!id || isNaN(level)) continue;

    // Create the Business Node
    concepts[id] = {
      id,
      label: r[E_IDX] || id,
      level,
      role: r[R_IDX] || "", // This allows the Reconstructor Regex to work
      isAbstract: String(r[A_IDX] || "").toLowerCase() === 'true',
      children: []
    };
    
    if (level === 1) roots.push(id);
  }

  return { concepts, roots };
}